// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FormDateInput_container__F8Z4s{
    display: inline-block;
}
.FormDateInput_label__\\+aDNH{
    display: block;
    color: #1F363D80;
    margin-left: 10px;
    margin-bottom: 8px;
    font-size: 14px;
    line-height: 14px;
}
.FormDateInput_asterisk__0et6E{
    margin-left: 5px;
    color: #EB443F;
}
.FormDateInput_inputContainer__6UrV5{
    position: relative;
}
.FormDateInput_input__ykC9J{
    height: 16px;
    width: 100%;
    padding: 28px 24px 28px 55px;
    color: #1F363D;
    background-color: #FFFFFF;
    border: 1px solid #1F363D1A;
    border-radius: 500px;
}
.FormDateInput_input__ykC9J::placeholder{
    color: #1F363D80;
}
.FormDateInput_input__ykC9J:focus{
    border: 1px solid #40798C;
    outline: none;
    box-shadow: 0 3px 12px 0 #40798C12;
}
.FormDateInput_input__ykC9J .react-date-picker__wrapper{
    position: relative;
    top: -14px;
    margin-left: -7px;
    border: none;
}
.FormDateInput_input__ykC9J .react-calendar__navigation{
    margin-bottom: 5px;
}
.FormDateInput_input__ykC9J .react-date-picker__inputGroup{
    height: 30px;
}
.FormDateInput_input__ykC9J .react-date-picker__inputGroup__input::placeholder{
    color: #1F363D80;
    font-size: 14px;
}
.FormDateInput_input__ykC9J .react-date-picker__inputGroup__input:focus-visible{
    outline: none;
}
.FormDateInput_input__ykC9J .react-date-picker__inputGroup__input:invalid{
    background-color: #FFFFFF;
}
.FormDateInput_input__ykC9J .react-date-picker__inputGroup__divider{
    color: #1F363D80;
    font-size: 14px;
}
.FormDateInput_input__ykC9J .react-calendar{
    padding: 5px;
    color: #1F363D;
    font-family: 'Gotham', serif;
    border: none;
    border-radius: 10px;
    box-shadow: 0 3px 12px 0 #00000012;
}
.FormDateInput_input__ykC9J .react-calendar__navigation > button{
    color: #1F363D;
    font-family: 'Gotham Medium', serif;
}
.FormDateInput_input__ykC9J .react-calendar__navigation > button:hover, .FormDateInput_input__ykC9J .react-calendar__navigation > button:focus, .FormDateInput_input__ykC9J .react-calendar__navigation > button:active,
.FormDateInput_input__ykC9J .react-calendar__navigation > button:disabled{
    background-color: #FFFFFF;
}
.FormDateInput_input__ykC9J .react-calendar__month-view__weekdays__weekday{
    font-family: 'Gotham Medium', serif;
}
.FormDateInput_input__ykC9J .react-calendar__month-view__weekdays__weekday > abbr{
    text-decoration: none;
}
.FormDateInput_input__ykC9J .react-calendar__year-view__months__month:hover, .FormDateInput_input__ykC9J .react-calendar__year-view__months__month:focus, .FormDateInput_input__ykC9J .react-calendar__year-view__months__month:active{
    background-color: #FFFFFF;
}
.FormDateInput_input__ykC9J .react-calendar__year-view__months__month.react-calendar__tile--hasActive{
    background-color: #FFFFFF;
}
.FormDateInput_input__ykC9J .react-calendar__year-view__months__month:disabled{
    color: #D3D3D3;
    background-color: #FFFFFF;
}
.FormDateInput_input__ykC9J .react-calendar__decade-view__years__year:hover, .FormDateInput_input__ykC9J .react-calendar__decade-view__years__year:focus, .FormDateInput_input__ykC9J .react-calendar__decade-view__years__year:active{
    background-color: #FFFFFF;
}
.FormDateInput_input__ykC9J .react-calendar__decade-view__years__year.react-calendar__tile--hasActive{
    background-color: #FFFFFF;
}
.FormDateInput_input__ykC9J .react-calendar__decade-view__years__year:disabled{
    color: #D3D3D3;
    background-color: #FFFFFF;
}
.FormDateInput_input__ykC9J .react-calendar__century-view__decades__decade:hover, .FormDateInput_input__ykC9J .react-calendar__century-view__decades__decade:focus,
.FormDateInput_input__ykC9J .react-calendar__century-view__decades__decade:active{
    background-color: #FFFFFF;
}
.FormDateInput_input__ykC9J .react-calendar__century-view__decades__decade.react-calendar__tile--hasActive{
    background-color: #FFFFFF;
}
.FormDateInput_input__ykC9J .react-calendar__century-view__decades__decade:disabled{
    color: #D3D3D3;
    background-color: #FFFFFF;
}
.FormDateInput_input__ykC9J .react-calendar__tile{
    height: 48px;
    width: 48px;
    color: #1F363D;
    border-radius: 100px;
}
.FormDateInput_input__ykC9J .react-calendar__tile--now{
    background-color: #FFFFFF;
}
.FormDateInput_input__ykC9J .react-calendar__tile--now.react-calendar__month-view__days__day:hover{
    background-color: #E6E6E6;
}
.FormDateInput_input__ykC9J .react-calendar__tile--now:focus, .FormDateInput_input__ykC9J .react-calendar__tile--now:active{
    background-color: #FFFFFF;
}
.FormDateInput_input__ykC9J .react-calendar__tile--active{
    color: #FFFFFF;
    background-color: #40798C;
    font-family: 'Gotham Medium', serif;
}
.FormDateInput_input__ykC9J .react-calendar__tile--active:hover{
    background-color: #40798C;
}
.FormDateInput_input__ykC9J .react-calendar__month-view__days__day:disabled{
    color: #D3D3D3;
    background-color: #FFFFFF;
}
.FormDateInput_input__ykC9J .react-calendar__month-view__days__day--neighboringMonth{
    color: #8F9B9E;
}
.FormDateInput_calendar__774P0{
    position: absolute;
    top: 18px;
    left: 20px;
    height: 24px;
    width: 24px;
}`, "",{"version":3,"sources":["webpack://./src/components/form/FormDateInput.module.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;AACzB;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,WAAW;IACX,4BAA4B;IAC5B,cAAc;IACd,yBAAyB;IACzB,2BAA2B;IAC3B,oBAAoB;AACxB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,yBAAyB;IACzB,aAAa;IACb,kCAAkC;AACtC;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,iBAAiB;IACjB,YAAY;AAChB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,YAAY;AAChB;AACA;IACI,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,aAAa;AACjB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,YAAY;IACZ,cAAc;IACd,4BAA4B;IAC5B,YAAY;IACZ,mBAAmB;IACnB,kCAAkC;AACtC;AACA;IACI,cAAc;IACd,mCAAmC;AACvC;AACA;;IAEI,yBAAyB;AAC7B;AACA;IACI,mCAAmC;AACvC;AACA;IACI,qBAAqB;AACzB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,cAAc;IACd,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,cAAc;IACd,yBAAyB;AAC7B;AACA;;IAEI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,cAAc;IACd,yBAAyB;AAC7B;AACA;IACI,YAAY;IACZ,WAAW;IACX,cAAc;IACd,oBAAoB;AACxB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,cAAc;IACd,yBAAyB;IACzB,mCAAmC;AACvC;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,cAAc;IACd,yBAAyB;AAC7B;AACA;IACI,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,YAAY;IACZ,WAAW;AACf","sourcesContent":[".container{\n    display: inline-block;\n}\n.label{\n    display: block;\n    color: #1F363D80;\n    margin-left: 10px;\n    margin-bottom: 8px;\n    font-size: 14px;\n    line-height: 14px;\n}\n.asterisk{\n    margin-left: 5px;\n    color: #EB443F;\n}\n.inputContainer{\n    position: relative;\n}\n.input{\n    height: 16px;\n    width: 100%;\n    padding: 28px 24px 28px 55px;\n    color: #1F363D;\n    background-color: #FFFFFF;\n    border: 1px solid #1F363D1A;\n    border-radius: 500px;\n}\n.input::placeholder{\n    color: #1F363D80;\n}\n.input:focus{\n    border: 1px solid #40798C;\n    outline: none;\n    box-shadow: 0 3px 12px 0 #40798C12;\n}\n.input :global(.react-date-picker__wrapper){\n    position: relative;\n    top: -14px;\n    margin-left: -7px;\n    border: none;\n}\n.input :global(.react-calendar__navigation){\n    margin-bottom: 5px;\n}\n.input :global(.react-date-picker__inputGroup){\n    height: 30px;\n}\n.input :global(.react-date-picker__inputGroup__input::placeholder){\n    color: #1F363D80;\n    font-size: 14px;\n}\n.input :global(.react-date-picker__inputGroup__input:focus-visible){\n    outline: none;\n}\n.input :global(.react-date-picker__inputGroup__input:invalid){\n    background-color: #FFFFFF;\n}\n.input :global(.react-date-picker__inputGroup__divider){\n    color: #1F363D80;\n    font-size: 14px;\n}\n.input :global(.react-calendar){\n    padding: 5px;\n    color: #1F363D;\n    font-family: 'Gotham', serif;\n    border: none;\n    border-radius: 10px;\n    box-shadow: 0 3px 12px 0 #00000012;\n}\n.input :global(.react-calendar__navigation > button){\n    color: #1F363D;\n    font-family: 'Gotham Medium', serif;\n}\n.input :global(.react-calendar__navigation > button:hover), .input :global(.react-calendar__navigation > button:focus), .input :global(.react-calendar__navigation > button:active),\n.input :global(.react-calendar__navigation > button:disabled){\n    background-color: #FFFFFF;\n}\n.input :global(.react-calendar__month-view__weekdays__weekday){\n    font-family: 'Gotham Medium', serif;\n}\n.input :global(.react-calendar__month-view__weekdays__weekday > abbr){\n    text-decoration: none;\n}\n.input :global(.react-calendar__year-view__months__month:hover), .input :global(.react-calendar__year-view__months__month:focus), .input :global(.react-calendar__year-view__months__month:active){\n    background-color: #FFFFFF;\n}\n.input :global(.react-calendar__year-view__months__month.react-calendar__tile--hasActive){\n    background-color: #FFFFFF;\n}\n.input :global(.react-calendar__year-view__months__month:disabled){\n    color: #D3D3D3;\n    background-color: #FFFFFF;\n}\n.input :global(.react-calendar__decade-view__years__year:hover), .input :global(.react-calendar__decade-view__years__year:focus), .input :global(.react-calendar__decade-view__years__year:active){\n    background-color: #FFFFFF;\n}\n.input :global(.react-calendar__decade-view__years__year.react-calendar__tile--hasActive){\n    background-color: #FFFFFF;\n}\n.input :global(.react-calendar__decade-view__years__year:disabled){\n    color: #D3D3D3;\n    background-color: #FFFFFF;\n}\n.input :global(.react-calendar__century-view__decades__decade:hover), .input :global(.react-calendar__century-view__decades__decade:focus),\n.input :global(.react-calendar__century-view__decades__decade:active){\n    background-color: #FFFFFF;\n}\n.input :global(.react-calendar__century-view__decades__decade.react-calendar__tile--hasActive){\n    background-color: #FFFFFF;\n}\n.input :global(.react-calendar__century-view__decades__decade:disabled){\n    color: #D3D3D3;\n    background-color: #FFFFFF;\n}\n.input :global(.react-calendar__tile){\n    height: 48px;\n    width: 48px;\n    color: #1F363D;\n    border-radius: 100px;\n}\n.input :global(.react-calendar__tile--now){\n    background-color: #FFFFFF;\n}\n.input :global(.react-calendar__tile--now.react-calendar__month-view__days__day:hover){\n    background-color: #E6E6E6;\n}\n.input :global(.react-calendar__tile--now:focus), .input :global(.react-calendar__tile--now:active){\n    background-color: #FFFFFF;\n}\n.input :global(.react-calendar__tile--active){\n    color: #FFFFFF;\n    background-color: #40798C;\n    font-family: 'Gotham Medium', serif;\n}\n.input :global(.react-calendar__tile--active:hover){\n    background-color: #40798C;\n}\n.input :global(.react-calendar__month-view__days__day:disabled){\n    color: #D3D3D3;\n    background-color: #FFFFFF;\n}\n.input :global(.react-calendar__month-view__days__day--neighboringMonth){\n    color: #8F9B9E;\n}\n.calendar{\n    position: absolute;\n    top: 18px;\n    left: 20px;\n    height: 24px;\n    width: 24px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `FormDateInput_container__F8Z4s`,
	"label": `FormDateInput_label__+aDNH`,
	"asterisk": `FormDateInput_asterisk__0et6E`,
	"inputContainer": `FormDateInput_inputContainer__6UrV5`,
	"input": `FormDateInput_input__ykC9J`,
	"calendar": `FormDateInput_calendar__774P0`
};
export default ___CSS_LOADER_EXPORT___;
